export const GET_APP_SETTINGS_FULFILLED = 'GET_APP_SETTINGS_FULFILLED';
export const GET_APP_SETTINGS_PENDING = 'GET_APP_SETTINGS_PENDING';
export const GET_APP_SETTINGS_REJECTED = 'GET_APP_SETTINGS_REJECTED';

export const POST_APP_SETTINGS_FULFILLED = 'POST_APP_SETTINGS_FULFILLED';
export const POST_APP_SETTINGS_PENDING = 'POST_APP_SETTINGS_PENDING';
export const POST_APP_SETTINGS_REJECTED = 'POST_APP_SETTINGS_REJECTED';

export const POST_NEW_API_KEY_FULFILLED = 'POST_NEW_API_KEY_FULFILLED';
export const POST_NEW_API_KEY_PENDING = 'POST_NEW_API_KEY_PENDING';
export const POST_NEW_API_KEY_REJECTED = 'POST_NEW_API_KEY_REJECTED';


export default (state = {
  apiKey: {
    key: '',
    created_at: '',
    accessed_at: '',
  },
  appVersion: {
    version: '',
    force_update: '',
  },
  fetching: false,
  fetched: false,
}, action) => {
  switch (action.type) {
    case GET_APP_SETTINGS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_APP_SETTINGS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        apiKey: action.payLoad.api_key,
        appVersion: action.payLoad.app_version,
      };
    }
    case POST_APP_SETTINGS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        appVersion: action.payLoad,
      };
    }
    case POST_NEW_API_KEY_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        apiKey: action.payLoad,
      };
    }
    case GET_APP_SETTINGS_REJECTED: {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
  }

  return {...state};
};



// WEBPACK FOOTER //
// ./src/reducers/appSettingsReducer.js